<div class="page_container">
  <slot />
</div>

